<script lang="ts">
export default {
  name: 'KkMultiCounterBar',
}
</script>
<script setup lang="ts">
import { onMounted, ref, nextTick } from 'vue'
import { KkProgressBar } from '../../../components/base'

interface Counter {
  label: string;
  currentCount: number;
  denominator: number;
}

const props = defineProps<{
  counters: Counter[];
}>()

const isOverMax = (currentCount: number, denominator: number): boolean => {
  return currentCount > denominator
}
const labelWidth = ref<number>(0)

onMounted(async () => {
  await nextTick()
  const labels = document.querySelectorAll('.counterLabel')
  let maxWidth = 0
  labels.forEach((label) => {
    const width = label.getBoundingClientRect().width
    if (width > maxWidth) maxWidth = width
  })
  labelWidth.value = maxWidth + 12
})
</script>
<template>
  <div class="multiCounterBar">
    <div v-for="item in props.counters" :key="item.label" class="counterItem">
      <span
        class="counterLabel"
        :style="{ minWidth: labelWidth + 'px' }"
        :class="{'overLabel': isOverMax(item.currentCount, item.denominator)}"
      >
        {{ item.label }} : <span class="counterFraction">({{ item.currentCount }}/{{ item.denominator }})</span>
      </span>
      <KkProgressBar :current-count="item.currentCount" :denominator="item.denominator" />
    </div>
  </div>
</template>
<style scoped>
.multiCounterBar {
  display: flex;
  flex-direction: column;
}

.counterItem {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.counterLabel {
  text-align: left;
  padding-right: 8px;
  font-size: 12px;
}
.counterFraction {
  font-weight: bold;
}
.overLabel {
  color: #E9446A;
}
</style>
